(function (angular) {
  "use strict";

  angular.module('myApp').component('menus', {
    templateUrl: '/menu/views/menuList.tpl.html',
    controller: [
      '$scope', 'aimList', 'flash',
      function ($scope, aimList, flash) {

        $scope.list = new aimList();
        $scope.list.url = 'api/admin/menus/';
        $scope.list.module = 'menu';
        $scope.list.actions = undefined;
        $scope.list.showPaging = true;
        $scope.list.load();

        $scope.qrCodeDownload = function (url, isApprovedUser) {
          if (!isApprovedUser)
            flash.show("لم تتم الموافقة على طلبكم  بعد", 0);
          else
            window.open(url, '_blank');
        }
      }
    ]
  });

}(window.angular));
